import { isNumber, isObject } from 'util';

import * as AppStateActions from '../actions/app-state';
import { Agency } from '../../services/agencies/agencies.model';

export interface State {
	selectedLanguage: string;
	agencies: Array<Agency>;
	selectedAgency: Agency;
	ssoSelectedAgencyId: number|null;
	showNeoFrame: boolean;
	showARGUSFrame: boolean;
	travelType: string;
}

export const InitialState: State = {
	selectedLanguage: '',
	agencies: [],
	selectedAgency: null,
	ssoSelectedAgencyId: sessionStorage.getItem('sso_agent_id') ? Number(sessionStorage.getItem('sso_agent_id')) : null,
	showNeoFrame: false,
	showARGUSFrame: false,
	travelType: 'XENA'
};

export function reducer(state: State = InitialState, action: AppStateActions.All): State {
	switch (action.type) {
		case AppStateActions.SWITCH_LANGUAGE:
			return {...state, selectedLanguage: action.payload};

		case AppStateActions.SET_AGENCIES:
			let selectedAgency = state.selectedAgency;

			if (state.ssoSelectedAgencyId && !selectedAgency) {
				selectedAgency = action.payload.find(agency => agency.agentId === state.ssoSelectedAgencyId);
			}

			if (!selectedAgency) {
				selectedAgency = action.payload.find(agency => agency.default) || action.payload[0];
			}

			return {
				...state,
				agencies: action.payload,
				selectedAgency: state.selectedAgency ? state.selectedAgency : selectedAgency,
			};

		case AppStateActions.SELECT_AGENCY:
			return {...state, selectedAgency: action.payload};

		case AppStateActions.SWITCH_NEO_FRAME:
			return {...state, showNeoFrame: !state.showNeoFrame};

		case AppStateActions.OPEN_NEO_FRAME:
			return {...state, showNeoFrame: true, travelType: action.payload ? action.payload : InitialState.travelType};

		case AppStateActions.CLOSE_NEO_FRAME:
			return {...state, showNeoFrame: false};

		case AppStateActions.OPEN_ARGUS_FRAME:
			return {...state, showARGUSFrame: true};

		case AppStateActions.CLOSE_ARGUS_FRAME:
			return {...state, showARGUSFrame: false};

		default:
			return state;
	}
}

export const GetSelectedLanguage = (s: State): string => s.selectedLanguage;
export const GetAgencies = (s: State): Array<Agency> => s.agencies;
export const GetSelectedAgency = (s: State): Agency => s.selectedAgency;
export const GetSSOSelectedAgencyId = (s: State): number => s.ssoSelectedAgencyId;
export const GetSelectedProvider = (s: State): number => isObject(s.selectedAgency) && isNumber(s.selectedAgency.providerId) ? s.selectedAgency.providerId : 0;
export const ShowNeoFrame = (s: State): boolean => s.showNeoFrame;
export const ShowARGUSFrame = (s: State): boolean => s.showARGUSFrame;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/app.ts